<template>
  <b-container fluid>
    <b-modal
      centered
      size="lg"
      id="modal-integrations"
      hide-footer
      :title="`${isEdit ? 'Edição' : 'Cadastro'} de integração`"
      @hidden="resetInfo"
    >
      <b-container tag="form" @submit.prevent="submitForm">
        <b-row>
          <b-col cols="12">
            <app-select
              :data="{
                options: listIntegrations,
                valueDefault: 'Escolha o tipo de integração',
                required: true,
              }"
              v-model="integration"
            />
          </b-col>
        </b-row>
        <hr />

        <b-row v-if="integration === 'AXUR_ONE' || integration === 'AXUR_DARK_WEB' " class="mt-3">
          <b-col cols="12" md="6">
            <app-select
              :data="{
                options: companies,
                valueDefault: 'Empresa',
                required: true,
              }"
              v-model="form.clientid"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="12" md="6" class="mt-md-0 mt-2">
            <app-select
              :data="{
                options: statusList,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="form.status"
            />
          </b-col>
          <b-col cols="12" md="6" class="mt-md-3 my-2 my-md-0">
            <b-form-input
              v-model="form.email"
              placeholder="E-mail"
              type="email"
              required
              :disabled="isEdit"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="6" class="mt-md-3">
            <b-form-input
              v-model="form.password"
              placeholder="Password"
              type="password"
              required
              :disabled="isEdit"
            ></b-form-input>
          </b-col>
          <b-col cols="12">
            <b-form-tags
              input-id="tags-basic"
              v-model="form.domainstoscan"
              placeholder="Domain para scanner"
              class="form-control mt-15"
              remove-on-delete
              required
              :disabled="isEdit"
            ></b-form-tags>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="mt-3 d-flex justify-content-end">
            <b-button
              variant="outline-warning"
              @click="$bvModal.hide('modal-integrations')"
            >
              <i class="fa fa-ban" aria-hidden="true"></i>
              Cancelar</b-button
            >
            <b-button variant="outline-primary" type="submit" class="ml-2">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Salvar</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-row class="py-4">
      <b-col class="d-flex justify-content-end">
        <b-button
          variant="dark"
          pill
          class="f-default"
          @click="
            $bvModal.show('modal-integrations');
            integration = undefined;
          "
          >Nova integração</b-button
        >
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-xl-12">
        <app-table
          :data-array="integrations"
          :fields="tableIntegrations"
          :rows="rows"
          title="Tabela Integrações"
          @keyword="setFilter('search', $event)"
          @perPage="setFilter('size', $event)"
          @currentPage="setFilter('page', $event)"
        >
          <template v-slot:actions="{ data }">
            <button
              class="
                btn btn-sm btn-outline-warning btn-rounded
                mx-2
                my-md-2 my-xl-0
              "
              @click="editInfo(data.item)"
              v-if="data.item.buttons.includes('edit')"
            >
              Editar
            </button>
            <button
              class="btn btn-sm btn-outline-danger btn-rounded"
              @click="removeInfo(data.item)"
              v-if="data.item.buttons.includes('remove')"
            >
              Remover
            </button>
          </template>
        </app-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import { mixins } from "@/mixins/mixins";
import api from "@/services/api";
import Swal from "sweetalert2";

export default {
  mixins: [mixins],
  data() {
    return {
      form: {},
      integration: "",
      statusList: [],
      companies: [],
      listIntegrations: [],
      integrations: [],
      tableIntegrations: [
        { key: "id", label: "ID" },
        { key: "type", label: "Tipo" },
        { key: "email", label: "Email" },
        { key: "status", label: "Status" },
        { key: "createdAt", label: "Data De Criação" },
        { key: "actions", label: "Ações" },
      ],
      idCompany: undefined,
      isEdit: false,
    };
  },
  mounted() {
    this.fetchInformation();
    this.getIntegrations();
    this.getCompanies();
    this.getStatus();
  },
  methods: {
    async submitForm() {
      try {
        this.$store.commit("utils/setLoading", true);
        let data = {
          ...this.form,
          status: this.form.status === 'Ativo' ? 'enable' : 'disable'
        };
        if(!this.isEdit){
          await api.addIntegration(data);
        }else{
          await api.putIntegration(data)
        }
        this.fetchInformation()
        this.form = {};
        this.$bvModal.hide("modal-integrations");
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },
    async fetchInformation() {
      this.$store.commit("utils/setLoading", true);
      try {
        const { data } = await api.getAxurLoki(this.filter);
        this.integrations = data
        this.integrations.content =
          data.content.map((mp) => {
            return {
              ...mp,
              status: this.getStatusName(mp.status),
              buttons: ["edit", "remove"],
            };
          }) || [];
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },

    getStatusName(item){
      const status = {
        disable:'Inativo',
        enable: 'Ativo',
        scanningDarkWeb: 'Scanning'
      }
      return status[item]
    },
    async getIntegrations() {
      try {
        const { data } = await api.getIntegrationsList();
        this.listIntegrations = Object.entries(data).map(([key, value]) => {
          return {
            value: key,
            text: value,
          };
        });
      } catch (error) {
        this.errorCatch(error);
      }
    },
    setFilter(origin, event) {
      switch (origin) {
        case "search":
          this.filter.search = event;
          break;
        case "page":
          this.filter.page = event;
          break;
        case "size":
          this.filter.size = event;
          break;
      }
    },
    async getCompanies() {
      this.$store.commit("utils/setLoading", true);
      try {
        this.companies = await api.getCompanies();
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },

    async getStatus() {
      this.$store.commit("utils/setLoading", true);
      try {
        const { data } = await api.getStatusLokiMonitoring();
        this.statusList = Object.entries(data).map(([, value]) => {
          return {
            value: value,
            text: value,
          };
        });
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },

    editInfo(item) {
      this.form = {
        ...item,
        status: item.status === 'Inativo' ? 'disable' : 'enable'
      };
      this.isEdit = true;
      this.$bvModal.show("modal-integrations");
    },
    async removeInfo(data) {
      const swal = await Swal.fire({
        title: "Atenção !",
        text: "Você deseja realmente remover?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      });
      if (swal.value) {
        try {
          this.$store.commit('utils/setLoading',true)
          await api.removeIntegration(data)
          this.fetchInformation()
        } catch (error) {
          this.errorCatch(error)
        } finally {
          this.$store.commit('utils/setLoading',false)

        }
      }
    },
    resetInfo() {
      this.isEdit = false;
      this.form = {};
    },
  },
};
</script>